import {
  UpdateHighlighter,
  type UpdateHighlighterProps,
} from "@rarible_int/anaconda_ui_components"
import { formatPercentage } from "../../../percentage/utils"

interface Props {
  value: number
  className?: string
}

export function Percentage(props: Props) {
  const percentage = formatPercentage(props.value)

  if (percentage === null || percentage === undefined) return "—"

  const format: UpdateHighlighterProps["format"] =
    percentage >= 1000
      ? {
          maximumFractionDigits: 1,
          maximumSignificantDigits: 3,
          notation: "compact",
        }
      : {
          maximumFractionDigits: 1,
        }

  return (
    <UpdateHighlighter
      value={percentage}
      format={format}
      suffix="%"
      className={props.className}
    />
  )
}
